import { Injectable } from '@angular/core';
import { Response, Http, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Configuration } from 'app/app.constants';
import { AuthenticationService } from 'app/shared/services/authentication.service';
import { Branch } from 'app/agatextscreens/accounting/branch';

@Injectable()
export class LocationService {
  // Use API
  _cityUrl = this._configuration.apiUrl + '/v2/city';
  _countryUrl = this._configuration.apiUrl + '/v2/country';
  _locationUrl = this._configuration.apiUrl + '/v2/location';

  constructor(private _http: Http,
    private _configuration: Configuration,
    public _authService: AuthenticationService) { }

  getCity(): Observable<any[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    return this._http.get(this._cityUrl, { headers: h, search: s }).map(
      response => {
        let body = response.json();
        if (body['cities'] == null || !Array.isArray(body['cities']))
          return [];
        return body['cities'];
      }
    );
  }

  getCountry(): Observable<any[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    return this._http.get(this._countryUrl, { headers: h, search: s }).map(
      response => {
        let body = response.json();
        if (body['countries'] == null || !Array.isArray(body['countries']))
          return [];
        return body['countries'];
      }
    );
  }

  addCity(city: { name: string, country_id: number }) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    return this._http.post(this._cityUrl, city, { headers: h, search: s }).map(response => response.json());
  }

  removeCity(id: string) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('id', id);

    return this._http.delete(this._cityUrl, { headers: h, search: s }).map(
      response => {
        let body = response.json();

        return Object.assign(body, { id: id });
      }
    );
  }

  getLocations(branch_id?: string) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    if (branch_id != null) {
      s.append('branch_id', branch_id);
    }

    return this._http.get(this._locationUrl, { headers: h, search: s }).map(
      response => {
        let body = response.json();
        if (body['locations'] == null || !Array.isArray(body['locations']))
          return [];
        return body['locations'];
      }
    );
  }

  addLocation(location: { name: string, branch_id: number }) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    return this._http.post(this._locationUrl, location, { headers: h, search: s }).map(response => response.json());
  }

  removeLocation(id: string) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('id', id);

    return this._http.delete(this._locationUrl, { headers: h, search: s }).map(
      response => {
        let body = response.json();

        return Object.assign(body, { id: id });
      }
    );
  }

  updateLocationName(id: string, name: string) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('id', id);

    return this._http.put(this._locationUrl, { name: name }, { headers: h, search: s }).map(response => response.json());
  }

}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/services/location.service.ts